<mat-toolbar class="main-header main-toolbar">
	<div class="vertical-menu toolbar-width">
		<button mat-button [matMenuTriggerFor]="menu" mat-icon-button fxShow="true" fxHide.gt-sm>
			<mat-icon>menu</mat-icon>
		</button>
		<h2 class="toolbar-logo">
			<img width="60" height="60" src="./assets/sass/pilotpay/img/logos/pilotpay.png" alt="" />
			<ng-container *ngIf="environment">{{ environment }} VERSION</ng-container>
		</h2>

		<div fxLayout="row" fxShow="false" fxShow.gt-sm>
			<nav mat-tab-nav-bar>
				<a
					mat-tab-link
					*ngIf="isAdmin"
					#rla="routerLinkActive"
					[routerLink]="['/pilotpay/admin']"
					routerLinkActive="active-link"
				>
					Dashboard
				</a>
				<a
					mat-tab-link
					*ngIf="!isAdmin"
					#rla="routerLinkActive"
					[routerLink]="['/pilotpay/dashboard']"
					routerLinkActive="active-link"
				>
					Dashboard
				</a>
				<a
					mat-tab-link
					*ngIf="isAdmin"
					#rla="routerLinkActive"
					[routerLink]="['/pilotpay/pay-scales']"
					routerLinkActive="active-link"
				>
					Pay Tables
				</a>
				<a
					mat-tab-link
					*ngIf="!isAdmin && payScaleId"
					#rla="routerLinkActive"
					[routerLink]="['/pilotpay/pay-scales/overview', payScaleId]"
					routerLinkActive="active-link"
				>
					Pay Table
				</a>
				<a
					mat-tab-link
					*ngIf="!isAdmin"
					#rla="routerLinkActive"
					[routerLink]="['/pilotpay/time-sheets', employeeId]"
					[queryParams]="{ date: todayDate }"
					routerLinkActive="active-link"
				>
					Time Sheets
				</a>
				<a
					mat-tab-link
					*ngIf="isAdmin"
					#rla="routerLinkActive"
					[routerLink]="['/pilotpay/pay-categories']"
					routerLinkActive="active-link"
				>
					Pay Categories
				</a>
				<a
					mat-tab-link
					*ngIf="isAdmin"
					#rla="routerLinkActive"
					[routerLink]="['/pilotpay/aircraft-models']"
					routerLinkActive="active-link"
				>
					Aircraft Models
				</a>
				<a
					mat-tab-link
					*ngIf="isAdmin"
					#rla="routerLinkActive"
					[routerLink]="['/pilotpay/job-titles']"
					routerLinkActive="active-link"
				>
					Job Titles
				</a>
				<a
					mat-tab-link
					*ngIf="isAdmin"
					#rla="routerLinkActive"
					[routerLink]="['/pilotpay/override-employees']"
					routerLinkActive="active-link"
				>
					Edit Employees
				</a>
				<a
					mat-tab-link
					*ngIf="isAdmin"
					#rla="routerLinkActive"
					[routerLink]="['/pilotpay/add-employee']"
					routerLinkActive="active-link"
				>
					Add Employee
				</a>
				<!--				<a mat-tab-link href="/docs/End-User-Documentation/About-this-Documentation.html">-->
				<!--					Help-->
				<!--				</a>-->
			</nav>
		</div>

		<mat-menu #menu>
			<button *ngIf="isAdmin" mat-menu-item [routerLink]="['/pilotpay/admin']">
				<mat-icon>explore</mat-icon>
				<span>Dashboard</span>
			</button>
			<button *ngIf="!isAdmin" mat-menu-item [routerLink]="['/pilotpay/dashboard']">
				<mat-icon>apps</mat-icon>
				<span>Dashboard</span>
			</button>
			<button *ngIf="isAdmin" mat-menu-item [routerLink]="['/pilotpay/pay-scales']">
				<mat-icon>table_chart</mat-icon>
				<span>Pay Tables</span>
			</button>
			<button
				*ngIf="!isAdmin && payScaleId"
				mat-menu-item
				[routerLink]="['/pilotpay/pay-scales/overview', payScaleId]"
			>
				<mat-icon>table_chart</mat-icon>
				<span>Pay Tables</span>
			</button>
			<button
				*ngIf="!isAdmin"
				mat-menu-item
				[routerLink]="['/pilotpay/time-sheets', employeeId]"
				[queryParams]="{ date: todayDate }"
			>
				<mat-icon>equalizer</mat-icon>
				<span>Timesheets</span>
			</button>
			<button *ngIf="isAdmin" mat-menu-item [routerLink]="['/pilotpay/pay-categories']">
				<mat-icon>list</mat-icon>
				<span>Pay Categories</span>
			</button>
			<button *ngIf="isAdmin" mat-menu-item [routerLink]="['/pilotpay/aircraft-models']">
				<mat-icon>list</mat-icon>
				<span>Aircraft Models</span>
			</button>
			<button *ngIf="isAdmin" mat-menu-item [routerLink]="['/pilotpay/job-titles']">
				<mat-icon>list</mat-icon>
				<span>Job Titles</span>
			</button>
			<button *ngIf="isAdmin" mat-menu-item [routerLink]="['/pilotpay/override-employees']">
				<mat-icon>edit</mat-icon>
				<span>Edit Employees</span>
			</button>
			<button *ngIf="isAdmin" mat-menu-item [routerLink]="['/pilotpay/add-employee']">
				<mat-icon>edit</mat-icon>
				<span>Add Employee</span>
			</button>
			<!--			<a mat-menu-item href="/docs/End-User-Documentation/About-this-Documentation.html" style="color: inherit;">-->
			<!--				<mat-icon>help</mat-icon>-->
			<!--				<span>Help</span>-->
			<!--			</a>-->
		</mat-menu>
		<span fxFlex></span>
		<mat-icon color="warn" *ngIf="!isConnected">signal_wifi_off</mat-icon>
		<div class="toolbar-right">
			<app-notifications-badge *ngIf="isAdmin && isConnected"></app-notifications-badge>
			<span *ngIf="!isAdmin" class="toolbar-user-name">
				{{ displayName }}
			</span>
			<span *ngIf="isAdmin">
				<button [mat-menu-trigger-for]="adminMenu" mat-button>
					{{ displayName }}
				</button>
				<mat-menu #adminMenu="matMenu" class="opt-menu" x-position="before">
					<button mat-menu-item (click)="openSetAdminUsersDialog()">
						<mat-icon>account_box</mat-icon>
						Set Administrators
					</button>
				</mat-menu>
			</span>
			<button (click)="logout()" mat-icon-button class="ml-xs" title="Sign Out">
				<mat-icon>exit_to_app</mat-icon>
			</button>
		</div>
	</div>
</mat-toolbar>
